import ReactPlayer from "react-player";
import { convertS3UrlToGcp } from "src/modules/worksheet/views/edit_enhanced/helpers";

const renderBlockVideo = (block: any) => {
    const {
        data: { video },
    } = block;
    return (
        <div>
            <ReactPlayer
                controls
                url={convertS3UrlToGcp(video)}
                style={{ maxWidth: "100%" }}
            />
        </div>
    );
};

export default renderBlockVideo;
